// Lightweight PIN hashing for parent gate UI. RLS is the real security boundary.
export async function hashPin(pin: string, salt: string): Promise<string> {
  const enc = new TextEncoder().encode(`jozori:v1:${salt}:${pin}`);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function isValidPin(p: string): boolean {
  return /^\d{4}$/.test(p);
}
